import request from '@/utils/request'

 // 查询整改方案的数量
export function queryAudit(data) {
  return request({
    url: 'rectification/queryAudit.do',
    method: 'post',
    loading: true,
    data: data
  })
}

 // 查询整改情况的数量
 export function queryAuditSituation(data) {
  return request({
    url: 'rectificationSituation/queryAudit.do',
    method: 'post',
    loading: true,
    data: data
  })
}

// 查询报告审核的数量
export function queryReportReview(data) {
  return request({
    url: 'inspection/queryReportReview.do',
    method: 'post',
    loading: true,
    data: data
  })
}

// 查询地域下拉数据
export function getAreaList(data) {
  return request({
    url: '/branchInfoTree/queryOrgCityBranchInfo.do',
    method: 'post',
    loading: true,
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/workDesk.js